import Card from "../../../../../../common/element/Card";
import Table from "../../../../../../common/element/Table";
import Tag from "../../../../../../common/element/Tag";
import Scrollbar from "../../../../../../common/element/ScrollBar";
import BtnLight from "../../../../../../common/element/Buttons/btnLight";
import { useNavigate, useParams } from "react-router-dom";
import { decryptId } from "../../../../../../common/encryptDecrypt/encryptdecrypt";
import { useDispatch } from "react-redux";
import moment from "moment/moment";
import { useEffect, useState } from "react";
import { GetProviderDashboardDueInvoicesByDays } from "../../../../../../actions/admin-provider/invoices/GetProviderDashboardDueInvoicesByDays";
const Billing = () => {
  const { Tr, Th, Td, THead, TBody } = Table;
  const [invoiceData, SetInvoiceData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const orgId = decryptId(id);
  useEffect(() => {
    dispatch(
      GetProviderDashboardDueInvoicesByDays({
        provider_org_id: "",
      })
    ).then((response) => {
      if (response.success) {
        SetInvoiceData(response.data);
      }
    });
  }, []);
  return (
    <Card className="py-6 border border-gray-200 rounded-xl dark-shadow">
      <div className="px-6">
        <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-3">
          <div className="flex items-center">
            <span className="mr-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
              >
                <path
                  d="M9.35156 14.6667C9.35156 15.9553 10.3962 17 11.6849 17H13.8516C15.2323 17 16.3516 15.8807 16.3516 14.5C16.3516 13.1193 15.2323 12 13.8516 12H11.8516C10.4709 12 9.35156 10.8807 9.35156 9.5C9.35156 8.11929 10.4709 7 11.8516 7H14.0182C15.3069 7 16.3516 8.04467 16.3516 9.33333M12.8516 5.5V7M12.8516 17V18.5M22.8516 12C22.8516 17.5228 18.3744 22 12.8516 22C7.32871 22 2.85156 17.5228 2.85156 12C2.85156 6.47715 7.32871 2 12.8516 2C18.3744 2 22.8516 6.47715 22.8516 12Z"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <p></p>
            <div className="flex flex-col">
              <span className="text-gray-900 text-base font-semibold">
                Billing
              </span>
              <p className="text-gray-600">Due in the next 30 days </p>
            </div>
          </div>
          <BtnLight
            className="w-20 h-9"
            onClick={() => navigate("/admin/provider/invoices")}
          >
            View All
          </BtnLight>
        </div>
      </div>

      <div className="max-h-[345px] overflow-y-auto cstm-scrollbar">
        <div>
          <div className="px-6">
            <div className="overflow-hidden border rounded-lg border-gray-200">
              <Table>
                <TBody>
                  {invoiceData?.length > 0 &&
                    invoiceData?.length != undefined &&
                    invoiceData?.map((item, index) => {
                      let status;
                      const renewalDate = new Date(
                        item?.upcoming_inv_renewal_date
                      );
                      const currentDate = new Date();
                      if (renewalDate < currentDate) {
                        status = "Overdue";
                      } else {
                        status = "Upcoming";
                      }

                      return (
                        <Tr>
                          <Td>{item?.xero_invoice_number}</Td>
                          <Td>
                            {status && (
                              <Tag
                                className={`${
                                  status == "Upcoming"
                                    ? "bg-warning-50 text-warning-700"
                                    : "bg-error-50 text-error-700"
                                } `}
                              >
                                <span>
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_18999_70113)">
                                      <path
                                        d="M11.35 5.75L10.3503 6.75L9.34998 5.75M10.4725 6.5C10.4907 6.33583 10.5 6.169 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C7.41363 10.5 8.67502 9.84817 9.5 8.82867M6 3.5V6L7.5 7"
                                        stroke={` ${
                                          status == "Upcoming"
                                            ? "#F79009"
                                            : "red"
                                        }`}
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_18999_70113">
                                        <rect
                                          width="12"
                                          height="12"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </span>{" "}
                                {status}
                              </Tag>
                            )}
                          </Td>
                          <Td>
                            {item?.invoice_send_date
                              ? moment(item?.invoice_send_date).format(
                                  "DD/MM/YYYY"
                                )
                              : "-"}
                          </Td>
                        </Tr>
                      );
                    })}
                  {(invoiceData?.length == 0 ||
                    invoiceData?.length == undefined) && (
                    <Td colSpan="2" className="text-center p-4">
                      No upcoming invoices
                    </Td>
                  )}
                </TBody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
export default Billing;
